import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { api } from '@/lib/api';

export function useServerClock(): Date | null {
  const { data } = useQuery({
    queryKey: ['health'],
    queryFn: () => api.health.get(),
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
  });

  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    if (!data?.serverTime) {
      return;
    }

    const serverAtFetch = new Date(data.serverTime).getTime();
    const clientAtFetch = Date.now();
    const offset = serverAtFetch - clientAtFetch;

    const tick = (): void => {
      setNow(new Date(Date.now() + offset));
    };

    tick();
    const intervalId = window.setInterval(tick, 1000);
    return () => {
      window.clearInterval(intervalId);
    };
  }, [data?.serverTime]);

  return now;
}
